import { render, staticRenderFns } from "./PrecisionMarketingList.vue?vue&type=template&id=dbf00e9a"
import script from "./PrecisionMarketingList.vue?vue&type=script&lang=js"
export * from "./PrecisionMarketingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports